import useUser from "@hooks/useUser"

import { faIcon } from "@utils/faIcon"

import { Menu } from "@organisms"

import { AvatarEditMenuProps } from "./AvatarEditMenu.types"

function AvatarEditMenu(props: AvatarEditMenuProps) {
    const { onUpload, onRemove, isOpen, onOpenChange, children } = props

    const { user } = useUser()

    const hasAvatar = Boolean(user?.avatar)

    const uploadNewImageItem = {
        title: "Upload new image",
        caption: "Under 512Kb in JPG, PNG, or WEBP",
        icon: faIcon({ name: "upload", style: "regular" }),
        onClick: () => {
            onUpload?.()
            onOpenChange?.(false)
        },
    }

    const removeImageItem = {
        title: "Remove",
        icon: faIcon({ name: "trash-can", style: "regular" }),
        onClick: () => {
            onRemove?.()
            onOpenChange?.(false)
        },
        variant: "danger" as const,
    }

    const menuItems = [
        {
            type: "group" as const,
            items: [uploadNewImageItem],
        },
        ...(hasAvatar
            ? [
                  { type: "divider" as const },
                  {
                      type: "group" as const,
                      items: [removeImageItem],
                  },
              ]
            : []),
    ]

    return (
        <Menu
            trigger={children}
            title="Edit avatar"
            items={menuItems}
            isOpen={isOpen}
            setIsOpen={onOpenChange}
            popoverAlign="start"
            popoverSide="right"
        />
    )
}

export default AvatarEditMenu
